import React from 'react'
import { Helmet } from 'react-helmet'
import PropTypes from 'prop-types'

const SITE_DOMAIN = 'https://atesautodetailing.net'
const DEFAULT_IMAGE = `${SITE_DOMAIN}/project-social-image.png`
const SITE_NAME = 'ATEŞ AUTO DETAILING'

const SEO = ({
  title,
  description,
  canonicalPath = '',
  image = DEFAULT_IMAGE,
  type = 'website',
  noindex = false,
}) => {
  // Trailing slash olmadan tutarlı ve standart canonical URL
  const normalizedPath =
    canonicalPath === '/' || canonicalPath === ''
      ? ''
      : canonicalPath.startsWith('/')
      ? canonicalPath.toLowerCase()
      : `/${canonicalPath.toLowerCase()}`

  const canonicalUrl = `${SITE_DOMAIN}${normalizedPath}`
  const imageUrl = image.startsWith('http') ? image : `${SITE_DOMAIN}${image}`

  return (
    <Helmet>
      {/* 1. Temel Sayfa Başlığı ve Açıklaması */}
      <title>{title}</title>
      {description && <meta name="description" content={description} />}

      {/* 2. Canonical URL Standartı */}
      <link rel="canonical" href={canonicalUrl} />

      {/* 3. Arama Motoru Direktifleri (Robots) */}
      {noindex ? (
        <meta name="robots" content="noindex, follow" />
      ) : (
        <meta
          name="robots"
          content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1"
        />
      )}

      {/* 4. Open Graph (Facebook, WhatsApp, LinkedIn vb.) */}
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={title} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:image" content={imageUrl} />
      <meta property="og:locale" content="tr_TR" />

      {/* 5. Twitter / X Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      {description && <meta name="twitter:description" content={description} />}
      <meta name="twitter:image" content={imageUrl} />
    </Helmet>
  )
}

SEO.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  canonicalPath: PropTypes.string,
  image: PropTypes.string,
  type: PropTypes.string,
  noindex: PropTypes.bool,
}

export default SEO
